( function() {
    "use strict";

    angular
        .module("ccsTrApp")
        .service("GpfsBatchCustomService", GpfsBatchCustomService);

    GpfsBatchCustomService.$inject = ['$http'];

    function GpfsBatchCustomService($http) {
        var service = {
            returnBatchInvoices: returnBatchInvoices,
            revertBatchInvoices: revertBatchInvoices
        };

        return service;

        function returnBatchInvoices(id) {
            var url = "api/gpfs-batches/" + id + "/invoices";
            return $http.get(url);
        }

        function revertBatchInvoices(id) {
            var url = "api/gpfs-batches/"+id+"/revert";
            return $http.get(url);
        }
    }
})();
